module.exports = __webpack_public_path__ + "media/images/desktop-universal-hollywood-bec92357aa90191aac7e68a3e092c5ed.jpg";